export class ReportGroup {
    reportGroupId: number;
    reportGroupName: string;
    reports: Report[];
    group: string;
}

export class Report {
    reportId: number;
    reportName: string;
    storedProcedure: string;
    reportGroup: ReportGroup;
}

export class ReportMetrics {
    signUps: number;
    averagePremiumPerNight: number;
    averagePremiumPerStay: number;
    totalBookings: number;
    totalNights: number;
    averageLengthOfStay: number;
    gwp: number;

    cashflowHiscox: number;
    cashflowGuardHog: number;
    cashflowIntroducers: number;
    cashflowTotal: number;
}
